<template>
    <div class="codics-aonaer-info-sys-header">
        <div class="codics-aonaer-info-sys-header-content">
            <el-image class="codics-aonaer-info-sys-header-logo" src="https://cdn.bosscaigou.com/huayuan/map/logo_b.svg"
                fit="fill"></el-image>
            <div class="codics-aonaer-info-sys-header-btn" @click="btnFuc">{{ isHome ? '返回首页' : '员工入口' }}</div>
        </div>
    </div>
</template>

<script>
import { jumpTo } from '@/utils/myutils';
export default {
    props: {
        isHome: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        btnFuc() {
            // this.$emit('update:showlogin', true);
            jumpTo(this, '个人中心', {}, {});
        }
    }
}
</script>

<style>
.codics-aonaer-info-sys-header {
    height: 100px;
    width: 100%;
    position: fixed;
    top: 0;
    border-bottom: 1px solid rgba(255, 255, 255, .1);
}

.codics-aonaer-info-sys-header img {
    user-select: none;
    -webkit-user-drag: none;
}

.codics-aonaer-info-sys-header-content {
    height: 100%;
    width: 100%;
    max-width: 1400px;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 25px;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-header-logo {
    height: 72.72px;
    width: 150px;
    position: relative;
    float: left;
    top: 50%;
    transform: translateY(-50%);
}

.codics-aonaer-info-sys-header-btn {
    height: 40px;
    width: fit-content;
    position: relative;
    float: right;
    line-height: 40px;
    text-align: center;
    color: #FFF;
    border-radius: 20px;
    box-sizing: border-box;
    border-radius: 20px;
    padding: 0 25px;
    border: 1px solid #FFF;
    top: 50%;
    transform: translateY(-50%);
    transition: .5s;
    cursor: pointer;
    user-select: none;
}

.codics-aonaer-info-sys-header-btn:hover {
    background: #ea5b18;
    border-color: #ea5b18;
}
</style>